<script>
  import { gql } from "@apollo/client/core";
  import { _ as t } from "svelte-i18n";

  import { client } from "../apollo";
  import { getLanguage } from "i18n/language.js";

  import { Button } from "t2c-components";
  import LangSwitch from "../components/LangSwitch.svelte";
  import Input from "components/Input.svelte";
  import Errors from "components/Errors.svelte";

  export let config;

  const LOGIN_MUTATION = gql`
    mutation ($email: String!, $password: String!) {
      loginClient(email: $email, password: $password) {
        clientAccess {
          email
        }
        lawyer {
          email
        }
      }
    }
  `;

  const CLIENT_RESET_PASSWORD_MUTATION = gql`
    mutation ($clientEmail: String!) {
      resetClientPassword(clientEmail: $clientEmail)
    }
  `;

  let done = false;

  let email = "";
  let password = "";

  let inFlight = false;

  let errorMessages = [];

  const login = async () => {
    const result = await client.mutate({
      mutation: LOGIN_MUTATION,
      variables: { email, password },
    });

    return result;
  };

  const recover = async (email) => {
    const result = await client.mutate({
      mutation: CLIENT_RESET_PASSWORD_MUTATION,
      variables: {
        clientEmail: email,
      },
    });

    return result;
  };

  const setErrorMessage = (message) => {
    errorMessages = [{ message: message }];
    // clear password input
    inFlight = false;
    password = "";
  };

  const handleLogin = () => {
    inFlight = true;
    login()
      .then((result) => {
        if (result.data.loginClient.clientAccess) {
          window.location.href = "/";
        } else if (result.data.loginClient.lawyer) {
          window.location.href = `https://app.time2client.com/${$getLanguage}/member/clients`;
        } else {
          setErrorMessage("authFail");
        }
      })
      .catch((error) => {
        console.error(error);
        setErrorMessage("authFail");
      });
  };

  const resetErrors = () => {
    errorMessages = [];
  };
  let recoverMessageVisible = false;

  const handleRecover = () => {
    recover(email)
      .then((result) => {
        if (result.data.resetClientPassword === "email_sent") {
          done = true;
          recoverMessageVisible = true;
        } else {
          setErrorMessage("errorSentMail");
        }
      })
      .catch((error) => {
        const { graphQLErrors, networkError } = error;
        const messages = graphQLErrors
          .map(({ message }) => message)
          .map((message) => $t(`errors.${message}`));
        setErrorMessage(messages);
      });
  };
  let resetFormvalid = false;
</script>

<div class="wrapper">
  <div class="modal">
    {#if config.logoHash}
      <div class="logo">
        <img
          src={`/download-file/logo/${config.id}?hash=${config.logoHash}`}
          alt="logo"
        />
      </div>
    {:else}
      <h1 class="title">{config.name}</h1>
    {/if}
    <h1 class="title">{$t("login.reservedArea")}</h1>
    <div class="grid">
      <div class="column">
        <form on:submit|preventDefault={handleLogin} class="form">
          <Input
            label={$t("login.email")}
            placeholder="mario.rossi@mail.com"
            type="email"
            on:change={resetErrors}
            on:focus={resetErrors}
            bind:value={email}
          />

          <Input
            label={$t("login.password")}
            on:change={resetErrors}
            on:focus={resetErrors}
            bind:value={password}
            type="password"
          />

          <Errors {errorMessages} />

          <input class="hide" type="submit" />
        </form>
      </div>
      <div class="column info">
        <div>
          <span>{$t("login.forgotPassword")}</span>
          <p style="font-style: italic;">{$t("login.recoverPassword")}</p>
        </div>

        {#if recoverMessageVisible}
          <p>
            {@html $t("login.checkMail", { values: { email } })}
          </p>
        {/if}
      </div>
    </div>
    <div class="grid">
      <div class="action">
        <Button style="primary" disabled={inFlight} on:click={handleLogin}>
          {$t("login.login")}
        </Button>
      </div>
      <div class="action">
        <Button disabled={inFlight} on:click={handleRecover}>
          {$t("login.recover")}
        </Button>
      </div>
    </div>
    <LangSwitch />
  </div>
</div>

<style>
  .wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 100vh;
    background-color: #eeeeee;
  }

  .wrapper::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: var(--client-background-image);
    background-size: cover;
    filter: grayscale(100%);
  }

  .modal {
    z-index: 1;
    margin-top: 48px;
    margin: 0 auto;
    max-width: 900px;
    padding: 24px;
    border: 2px solid black;
    background-color: rgba(255, 255, 255, 0.95);
  }

  .grid {
    display: grid;
    grid-template-columns: 1fr;
  }

  @media only screen and (min-width: 30em) {
    .grid {
      grid-template-columns: 1fr 1fr;
      column-gap: 48px;
    }
  }

  .action {
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
  }

  h1 {
    font-size: 26px;
    font-weight: 400;
    text-transform: uppercase;
  }

  .info {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .hide {
    position: absolute;
    width: 1px;
    height: 1px;
    left: -9999px;
  }

  .logo {
    display: flex;
    justify-content: center;
  }

  .logo img {
    height: 150px;
  }

  .title {
    line-height: 2.5rem;
  }
</style>
